import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

const DEFAULT_CONTENT_GAP = "16px";

export const rootStyle = css`
  display: flex;
  flex-direction: column;
  padding-left: ${DEFAULT_CONTENT_GAP};
  padding-right: ${DEFAULT_CONTENT_GAP};

  &::before {
    content: "";
    border-top: 1px solid #d4d4d4;
  }
`;

export const liveCardStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: ${DEFAULT_CONTENT_GAP};
  padding: ${DEFAULT_CONTENT_GAP};
`;

export const goodsCardStyle = css`
  display: flex;
  flex-direction: row;
  column-gap: ${DEFAULT_CONTENT_GAP};

  ${MEDIA_QUERY_FOR_PC} {
    margin-top: ${DEFAULT_CONTENT_GAP};
    padding-bottom: ${DEFAULT_CONTENT_GAP};
  }

  ${MEDIA_QUERY_FOR_SP} {
    margin-top: 32px;
    padding-bottom: ${DEFAULT_CONTENT_GAP};
  }
`;

export const thumbnailImageStyle = css`
  width: 80px;
  height: 80px;
  object-fit: fill;
`;

export const liveImageContainerStyle = css`
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;

  ${MEDIA_QUERY_FOR_PC} {
    margin-top: 24px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    margin-top: 16px;
  }
`;

export const liveImageStyle = css`
  width: 100%;
  max-width: 440px;
  height: 185px;
  object-fit: contain;
`;

export const liveImageSkeletonStyle = css`
  width: 100%;
  max-width: 440px;
  height: 185px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const thumbnailSkeletonStyle = css`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const infoTextStyle = css`
  display: flex;
  flex-wrap: wrap;
  column-gap: 8px;
  color: #1e1e1e;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
`;

export const infoTextItemStyle = css`
  flex-shrink: 0;
`;

export const statusBarStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const statusBadgeStyle = css`
  display: flex;
  height: 24px;
  padding-left: 8px;
  padding-right: 8px;
  align-items: center;
  background-color: #333;
  /* テキストスタイル */
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;
